module.exports = __webpack_public_path__ + "img/dgjg2332_1.c7c6a243.svg";